export enum IndicadorExento {
   "",
   "Exento",
   "No facturable",
}
